import ThresholdType from '../constants/ThresholdType';

export default class Threshold {
  type = ThresholdType.SUMMER;
  caution = 0;
  bad = 0;

  static withData(data: Partial<Threshold>): Threshold {
    return Object.assign(new Threshold(), data);
  }
}
